import type { IScore, TScoreTypeNames } from '../../models';
import { findScore } from '../../helpers/common';

/** Возвращает признак наличия всех необходимых данных для отображения альфарейтинг графика */
export const isNotAllNeededScoresExist = (
    scores: IScore[],
    allNeededTypeNames: TScoreTypeNames[]
): boolean =>
    allNeededTypeNames.some(typeName => {
        const score = findScore(typeName, scores);

        return !score || score.value === 0 || score.value > 10;
    });
